import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TranslationService } from '../../services/translation.service'
import { ConfigService } from 'src/app/services/config.service'
import { AssetsService } from '../../services/assets.service'

@Component({
  selector: 'fleet-footer',
  standalone: true,
  imports: [RouterModule],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  translate: any
  backofficeConfig: any
  privacyCenterUrl: string = ''
  privacyPolicyUrl: string = ''
  connectedTermsAndServiceUrl: string = ''
  websiteTermsofUseUrl: string = ''
  manageYourPrivacyChoicesUrl: string = ''
  contactUrl: string = ''
  twitterUrl: string = ''
  facebookUrl: string = ''
  instagramUrl: string = ''
  linkedInUrl: string = ''
  youTubeUrl: string = ''
  twitterIcon: any
  facebookIcon: any
  youTubeIcon: any
  instagramIcon: any
  linkedInIcon: any

  constructor(
    private translationService: TranslationService,
    private configService: ConfigService,
    private assetsService: AssetsService
  ) {}

  ngOnInit() {
    this.translate = this.translationService.getTranslationForPage('footer')
    this.backofficeConfig = this.configService.getBackOfficeConfig()
    this.privacyCenterUrl =
      this.backofficeConfig['EXTERNAL_LINKS']['PRIVACY_CENTER']
    this.privacyPolicyUrl =
      this.backofficeConfig['EXTERNAL_LINKS']['PRIVACY_POLICY']
    this.connectedTermsAndServiceUrl =
      this.backofficeConfig['EXTERNAL_LINKS']['CONNECTED_TERMS_SERVICE']
    this.websiteTermsofUseUrl =
      this.backofficeConfig['EXTERNAL_LINKS']['WEBSIT_TERMS_OF_USE']
    this.manageYourPrivacyChoicesUrl =
      this.backofficeConfig['EXTERNAL_LINKS']['MANAGE_YOUR_PRIVACY_CHOICES']
    this.contactUrl = this.backofficeConfig['EXTERNAL_LINKS']['CONTACT']
    this.twitterUrl = this.backofficeConfig['SOCIAL_MEDIA']['TWITTER'],
      this.instagramUrl = this.backofficeConfig['SOCIAL_MEDIA']['INSTAGRAM'],
      this.facebookUrl = this.backofficeConfig['SOCIAL_MEDIA']['FACEBOOK'],
      this.linkedInUrl = this.backofficeConfig['SOCIAL_MEDIA']['LINKEDIN'],
      this.youTubeUrl = this.backofficeConfig['SOCIAL_MEDIA']['YOUTUBE']
    this.setAssets()
  }
  setAssets() {
    this.facebookIcon = this.assetsService.getAsset('2118_Facebook')
    this.instagramIcon = this.assetsService.getAsset('2119_Instagram')
    this.linkedInIcon = this.assetsService.getAsset('2120_Linkedin')
    this.twitterIcon = this.assetsService.getAsset('2333_Xlogo')
    this.youTubeIcon = this.assetsService.getAsset('2124_Youtube')
  }
  preventClick(event: any) {
    event.preventDefault()
  }
}
